<template>
  <div class="changeattr">
    <el-card class="card">
      <div slot="header"
           class="clearfix">
        <span>修改扩展属性</span>
      </div>
      <el-form ref="data"
               :model="data"
               status-icon
               label-width="70px"
               class="demo-ruleForm"
               :rules="rules">
        <el-form-item label="属性名"
                      prop="attrName">
          <el-input v-model="data.attrName" size="mini"
                    placeholder="请输入属性名"></el-input>
        </el-form-item>
        <el-form-item label="属性值"
                      prop="attrValue">
          <el-input v-model.number="data.attrValue" size="mini"
                    placeholder="请输入属性值"></el-input>
        </el-form-item>
      </el-form>
      <div class="btnmg">
        <el-button type="primary" size="mini"
                    @click="submitForm('data')">保存</el-button>
        <el-button size="mini" @click="resetForm('data')">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'changeattr',
  props: ['modalInfo'],
  data() {
    return {
      data: {
        attrName: '',
        attrValue: ''
      },
      rules: {
        attrName: [
          { required: true, message: '请输入属性名', trigger: 'blur' }
        ],
        attrValue: [
          { required: true, message: '请输入属性值', trigger: 'blur' }
        ]
      },
      bit: null
    }
  },
  created() {
    this.data.attrName = this.modalInfo.propertyname
    this.data.attrValue = this.modalInfo.provalue
  },
  methods: {
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 上传新数据接口
          ApiService.tree.addextraprop({
            mileageID: window.R_config.modelId,
            bitNumber: window.Muster,
            propertyname: this.data.attrName,
            provalue: this.data.attrValue,
            id: this.modalInfo.id
          }).then(res => {
            if (res.code == '0') {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.getproperty()
              this.$store.commit('closeModal', 'changeattr')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 取消、关闭
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$store.commit('closeModal', 'changeattr')
    },
    getproperty() {
      ApiService.tree
        .property({
          mileageID: window.R_config.modelId,
          bitNumber: window.Muster
        })
        .then(res => {
          if (res.code == 0) {
            let attrData = res.data
            this.$store.commit('syncAttrData', attrData)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/css/color.scss';
.changeattr {
  .card {
    width: 342px;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/changeattr.vue